import React, { useState, useEffect, useRef } from 'react';
import LoadingOverlay from 'react-loading-overlay';
import BeatLoader from 'react-spinners/BeatLoader';
import Slide from '@material-ui/core/Slide';
import { makeStyles } from '@material-ui/core/styles';
import { withNamespaces } from 'react-i18next';
import i18next from 'i18next';
import ScheduleWeekSelect from '@components/prototypeSchedule/ScheduleWeekSelect'
import styles from '@styles/punch.module.css';
import PunchCCQList from '@components/punchCCQ/PunchCCQList'
import AlertAlgo from '@components/controls/AlertSnack';
import * as punchListType from '@scripts/PunchListType';

const useStyles = makeStyles((theme) => ({
    appBar: {
        backgroundColor: 'var(--color1) !important',
        color: 'var(--color2) !important'
    },
    title: {
        marginLeft: theme.spacing(2),
        flex: 1,
    },
    buttonSection: {
        paddingBottom: '0px!important'
    },
    form: {
        paddingBottom: '0px!important'
    },
    divLoading: {
        marginTop: '3px'
    },
    warningGeolocation: {
        backgroundColor: '#ff7b7b',
        color: '#ffffff',
        padding: '10px'
    }
}));

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

export function PunchCCQWeek(props) {
    const classes = useStyles();
    const alertRef = useRef(null);

    const [isActive, setIsActive] = useState(true);
    const [dates, setDates] = useState({});
    const [selectedDate, setSelectedDate] = useState(new Date());

    useEffect(() => {
    }, []);

    useEffect(() => {
        loadPage();
    }, [dates]);

    const loadPage = () => {
        setIsActive(false);
    }

    const showMessageError = (msg) => {
        alertRef.current.showMessageError(msg);
    }

    const showMessageWarning = (msg) => {
        alertRef.current.showMessageWarning(msg);
    }

    const showMessageSuccess = (msg) => {
        alertRef.current.showMessageSuccess(msg);
    }

    const onChangeDate = (startDateChange, endDateChange) => {
        let datesChange = {};
        datesChange.startDate = startDateChange;
        datesChange.endDate = endDateChange;

        setDates(datesChange);
    }

    return (
        <LoadingOverlay
            className={classes.divLoading}
            active={isActive}
            spinner={<BeatLoader />}
            text={i18next.t('punch:form.loading')}
        >
            <div id="divPunchRoot" className={styles.punchCcqWrapper}>
                <ScheduleWeekSelect onChangeDate={onChangeDate} selectedDate={selectedDate} />

                {
                    <div data-id="divPunch" className={styles.divPunchForm}>
                        <PunchCCQList punchListType={punchListType.WEEK} dates={dates}></PunchCCQList>
                    </div>
                }
                <AlertAlgo ref={alertRef} />
            </div>
        </LoadingOverlay>
    )
}

export default withNamespaces(['punch'], { wait: true })(PunchCCQWeek);